module.exports = __webpack_public_path__ + "img/studium.72527d96.png";